import React from "react";
import { Box, Button, Modal } from "@mui/material";
import styled from "styled-components";

type ConfirmModalProps = {
  open: boolean;
  title?: string;
  message?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function ConfirmModal({
  open,
  title = "Potvrda",
  message = "Da li ste sigurni?",
  confirmLabel = "Potvrdi",
  cancelLabel = "Otkaži",
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          onCancel();
        }
      }}
      aria-labelledby="confirm-modal-title"
      aria-describedby="confirm-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "min(92vw, 32rem)",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 2,
          p: 3,
        }}
      >
        <Title id="confirm-modal-title">{title}</Title>
        <Description id="confirm-modal-description">{message}</Description>
        <Actions>
          <Button variant="outlined" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button variant="contained" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </Actions>
      </Box>
    </Modal>
  );
}

const Title = styled.h3`
  margin: 0 0 0.75rem;
`;

const Description = styled.div`
  margin-bottom: 1.5rem;
  line-height: 1.5;
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
`;
